<article class="relative flex flex-col gap-4 rounded-xl border border-l-4 border-border bg-card p-4 shadow-sm md:flex-row md:items-start">

    <div class="relative aspect-9/16 w-32 shrink-0 overflow-hidden rounded-lg border border-border bg-muted">
        @if (hasMedia()) {
        @if (mediaIsVideo()) {
        <video class="h-full w-full object-cover" muted playsinline preload="metadata" [src]="mediaUrl()"
            [attr.aria-label]="mediaAlt()"></video>
        } @else {
        <img class="h-full w-full object-cover" [src]="mediaUrl()" [alt]="mediaAlt()" />
        }
        } @else {
        <div class="grid h-full place-items-center gap-1 text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6" aria-hidden="true">
                <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
            </svg>
            <p class="m-0 text-xs font-bold uppercase tracking-wide">Placeholder</p>
        </div>
        }
        <p class="absolute left-2 top-2 m-0 rounded-md border border-dashed border-border bg-card px-1.5 py-0.5 text-xs text-muted-foreground">
            Platform</p>
    </div>

    <div class="min-w-0 flex-1">
        <div class="flex flex-wrap items-center gap-2.5">
            <p class="m-0 grid size-8 shrink-0 place-items-center rounded-full bg-muted text-xs font-bold text-foreground"
                aria-hidden="true">{{ post().initials }}</p>
            <div class="min-w-0">
                <p class="m-0 text-base font-bold leading-tight text-foreground">{{ post().creatorName }}</p>
            </div>
            <p class="m-0 rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 dark:bg-red-400/10 dark:text-red-400">
                {{ issueLabel() }}</p>
            <p class="m-0 rounded-full border border-dashed border-border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Rule breach or missing</p>
        </div>

        @if (ruleState() === 'ready') {
        <div class="mt-3 flex flex-col gap-3 rounded-lg border border-border bg-muted p-3">
            @for (rule of failedRules(); track $index) {
            <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-muted-foreground">{{ ruleCaption(rule.type) }}</p>
                <p class="m-0 mt-1 text-sm text-foreground">{{ rule.statement }}</p>
            </div>
            }
        </div>
        } @else if (ruleState() === 'loading') {
        <p class="m-0 mt-3 text-sm text-muted-foreground" aria-busy="true">Loading rule…</p>
        } @else if (ruleState() === 'error') {
        <p class="m-0 mt-3 rounded-md border border-dashed border-border px-2 py-1 text-sm text-muted-foreground">Rule unavailable</p>
        } @else {
        <div class="mt-3 rounded-lg border border-dashed border-border bg-muted p-3">
            <p class="m-0 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Rule</p>
            <p class="m-0 mt-1 text-sm text-muted-foreground">Rule statement</p>
        </div>
        }

        @if (ruleState() === 'ready' && findings().length) {
        <div class="mt-3 flex flex-col gap-2">
            @for (finding of findings(); track $index) {
            <p class="m-0 text-sm leading-relaxed text-foreground">{{ finding }}</p>
            }
        </div>
        } @else {
        <p class="m-0 mt-3 rounded-md border border-dashed border-border px-2 py-1 text-sm text-muted-foreground">Finding</p>
        }

        <div class="mt-3 flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
            @if (ruleState() === 'ready' && ruleTypeLabels().length) {
            @for (label of ruleTypeLabels(); track label) {
            <p class="m-0 rounded px-1.5 py-0.5 text-xs font-bold uppercase tracking-wide"
                [class]="label === 'Subjective' ? 'bg-brand-studio/10 text-brand-studio-dark dark:text-brand-studio' : 'bg-teal-500/10 text-teal-700 dark:text-teal-300'">{{ label }}</p>
            }
            } @else {
            <p class="m-0 rounded-md border border-dashed border-border px-2 py-0.5">Rule type</p>
            }
            <p class="m-0">Content <b class="font-semibold text-foreground">{{ positionLabel() }}</b></p>
        </div>
    </div>

    <div class="flex w-full shrink-0 flex-col items-stretch gap-2 md:w-44">
        <p class="m-0 inline-flex items-center justify-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1.5 text-xs font-semibold text-amber-800 dark:bg-amber-400/10 dark:text-amber-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3.5" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </svg>
            Needs review
        </p>
        @if (hasMedia()) {
        <button type="button" (click)="watch()"
            class="btn-shout btn-shout-sm btn-shout-secondary w-full justify-center" [attr.aria-label]="watchLabel()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
                <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
            </svg>
            Watch
        </button>
        <scr-screening-details-drawer #detailsDrawer class="absolute" [content]="post().item" [briefId]="briefId()"
            [showTrigger]="false" />
        } @else {
        <button type="button" disabled class="btn-shout btn-shout-sm btn-shout-secondary w-full justify-center"
            [attr.aria-label]="watchLabel() + '. No media link yet'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
                <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
            </svg>
            Watch
        </button>
        }

        <button type="button" (click)="override()"
            class="btn-shout btn-shout-sm btn-shout-tertiary w-full justify-center"
            [attr.aria-label]="overrideLabel()">
            Override
        </button>
        <scr-override-decision-drawer #overrideDrawer class="absolute" [content]="post().item"
            [briefId]="briefId()" (overridden)="onOverridden($event)" />
    </div>
</article>
